<template>
  <div id="data-list-thumb-view" class="data-list-container">
    <vs-table id="orderLogsTable" :max-items="itemsPerPage" :data="orderLogs">
      <div
        slot="header"
        class="w-full flex flex-wrap items-center flex-grow justify-between"
      >
        <vs-row vs-type="flex" vs-w="12" class="mb-1">
          <global-filter
            ref="filterer"
            :tableOptions="tableOptions"
            :filterOptions="filterOptions"
            :filterChips="filterChips"
            :filterOptionNames="filterOptionNames"
            :isActive="isFilterActive"
            @saveOptions="saveOptions"
            @close="isFilterActive = false"
          />
          <vs-row
            id="panelHeaderRow"
            v-show="!isFilterActive"
            vs-type="flex"
            vs-w="12"
            vs-justify="space-between"
          >
            <vs-col
              id="panel-actions"
              vs-type="flex"
              class="w-auto"
              vs-justify="center"
            >
              <vs-row vs-type="flex" vs-w="12" vs-align="center">
                <vs-col vs-type="flex" class="w-auto">
                  <vx-tooltip text="Detaylı Filtreleme" position="top">
                    <vs-button
                      @click="isFilterActive = !isFilterActive"
                      class="panel-action text-warning xlarge-button panel-action-box-shadow"
                      color="transparent"
                      icon-pack="pickicon"
                      icon="icon-pick-filter"
                    >
                    </vs-button>
                  </vx-tooltip>
                </vs-col>
                <vs-col vs-type="flex" class="w-auto">
                  <vx-tooltip text="Excel Export" position="top">
                    <vs-button @click="getExcel" class="panel-action text-dark xlarge-button panel-action-box-shadow"
                               color="transparent" icon-pack="feather" icon="icon-download">
                    </vs-button>
                  </vx-tooltip>
                </vs-col>
              </vs-row>
            </vs-col>
            <vs-col id="filter-chips" vs-type="flex">
              <vs-row
                vs-type="flex"
                vs-w="12"
                vs-justify="center"
                vs-align="center"
              >
                <vs-button
                  id="clearFilterButton"
                  v-if="filterChips.length > 0"
                  @click="clearFilter"
                  class="mr-2 bg-white text-danger panel-action-box-shadow"
                  icon-pack="feather"
                  icon="icon-slash"
                  radius
                  color="transparent"
                />
                <vs-col
                  vs-type="flex"
                  class="w-auto"
                  v-for="(chip, index) in filterChips"
                  :key="index"
                >
                  <vs-chip
                    color="white"
                    class="panel-action-box-shadow px-1"
                    @click="removeFilter(chip.col, index)"
                    v-show="chip.value != ''"
                    closable
                  >
                    <vs-row vs-tpye="flex" vs-w="12">
                      <vs-col vs-tpye="flex" class="w-auto" vs-align="center">
                        <span class="bold text-xsmaller text-dark">
                          {{ chip.name + " :" }}
                        </span>
                      </vs-col>
                      <vs-col
                        vs-type="flex"
                        class="w-auto ml-1"
                        vs-align="center"
                      >
                        <feather-icon
                          v-if="chip.value === true"
                          icon="CheckIcon"
                          svgClasses="w-4 h-4 text-primary"
                        />
                        <feather-icon
                          v-else-if="chip.value === false"
                          icon="XIcon"
                        />
                        <span
                          v-else
                          class="weight-600 italic text-xsmaller text-primary"
                        >
                          {{ chip.value }}
                        </span>
                      </vs-col>
                    </vs-row>
                  </vs-chip>
                </vs-col>
              </vs-row>
            </vs-col>
            <vs-col
              id="table-page-size"
              vs-type="flex"
              class="w-auto"
              vs-justify="flex-end"
            >
              <vs-dropdown
                vs-trigger-click
                class="bg-white cursor-pointer panel-action-box-shadow"
              >
                <div
                  class="px-4 d-theme-border-grey-light d-theme-dark-bg cursor-pointer flex items-center justify-between text-small"
                >
                  <span class="mr-2 page-size-dropdown-span"
                    >{{ (currentPage + 1) * itemsPerPage - (itemsPerPage - 1) }}
                    -
                    {{
                      totalDataRow - (currentPage + 1) * itemsPerPage > 0
                        ? (currentPage + 1) * itemsPerPage
                        : totalDataRow
                    }}
                    of
                    {{ totalDataRow }}</span
                  >
                  <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                </div>
                <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
                <vs-dropdown-menu>
                  <vs-dropdown-item @click="itemsPerPage = 10">
                    <span>10</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="itemsPerPage = 15">
                    <span>15</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="itemsPerPage = 20">
                    <span>20</span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </vs-col>
          </vs-row>
        </vs-row>
      </div>

      <template slot="thead">
        <vs-th style="width: 6%; text-align: center; justify-content: center;">
          <vs-button class="p-1 weight-600 w-full text-center" color="primary" type="flat" style="justify-content: center;">
             Yazdır
          </vs-button>
        </vs-th>
        <vs-th style="width: 8%; text-align: center; justify-content: center;">
          <vs-button
            class="p-1 weight-600 w-full text-center"
            icon-pack="feather"
            :icon="tableOptions.sortBy == 'id' ? sortingHeadIcon : null"
            color="primary"
            type="flat"
            @click="setSortingOptions('id')"
            style="justify-content: center;"
            >Sipariş No
          </vs-button>
        </vs-th>
        <vs-th style="width: 10%; text-align: center; justify-content: center;">
          <vs-button class="p-1 weight-600 w-full text-center" color="primary" type="flat" style="justify-content: center;">
            Sipariş Türü
          </vs-button>
        </vs-th>
        <vs-th style="width: 10%; text-align: center; justify-content: center;">
          <vs-button
            class="p-1 weight-600 w-full text-center"
            icon-pack="feather"
            :icon="tableOptions.sortBy == 'created' ? sortingHeadIcon : null"
            color="primary"
            type="flat"
            @click="setSortingOptions('created')"
            style="justify-content: center;"
            >Tarih
          </vs-button>
        </vs-th>
        <vs-th style="width: 8%; text-align: center; justify-content: center;">
          <vs-button
            class="p-1 weight-600 w-full text-center"
            icon-pack="feather"
            :icon="tableOptions.sortBy == 'created' ? sortingHeadIcon : null"
            color="primary"
            type="flat"
            @click="setSortingOptions('created')"
            style="justify-content: center;"
            >Saat
          </vs-button>
        </vs-th>
        <vs-th style="width: 12%; text-align: center; justify-content: center;">
          <vs-button class="p-1 weight-600 w-full text-center" color="primary" type="flat" style="justify-content: center;">
            Şube
          </vs-button>
        </vs-th>
        <vs-th style="width: 10%; text-align: center; justify-content: center;">
          <vs-button class="p-1 weight-600 w-full text-center" color="primary" type="flat" style="justify-content: center;">
            Brüt Tutar
          </vs-button>
        </vs-th>
        <vs-th style="width: 10%; text-align: center; justify-content: center;">
          <vs-button class="p-1 weight-600 w-full text-center" color="primary" type="flat" style="justify-content: center;">
            İndirim
          </vs-button>
        </vs-th>
        <vs-th style="width: 10%; text-align: center; justify-content: center;">
          <vs-button
            class="p-1 weight-600 w-full text-center"
            icon-pack="feather"
            :icon="tableOptions.sortBy == 'totalPrice' ? sortingHeadIcon : null"
            color="primary"
            type="flat"
            @click="setSortingOptions('totalPrice')"
            style="justify-content: center;"
            >Net Tutar
          </vs-button>
        </vs-th>
        <vs-th style="width: 16%; text-align: center; justify-content: center;">
          <vs-button
            class="p-1 weight-600 w-full text-center"
            icon-pack="feather"
            :icon="
              tableOptions.sortBy == 'createdUser' ? sortingHeadIcon : null
            "
            color="primary"
            type="flat"
            @click="setSortingOptions('createdUser')"
            style="justify-content: center;"
            >Personel
          </vs-button>
        </vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td style="width: 6%; justify-content: center;">
             <vs-button 
                radius 
                color="dark" 
                type="border"
                size="small"
                icon-pack="feather" 
                icon="icon-printer"
                @click.stop="printOrderManual(tr)">
             </vs-button>
          </vs-td>
          <vs-td style="width: 8%; justify-content: center;" class="font-bold">
            {{ tr.id }}
          </vs-td>
          <vs-td style="width: 10%; justify-content: center;" class="text-center font-bold">
            {{ getOrderSourceBadge(tr).text }}
          </vs-td>
          <vs-td style="width: 10%; justify-content: center;">
            {{ tr.date }}
          </vs-td>
          <vs-td style="width: 8%; justify-content: center;">
            {{ tr.time }}
          </vs-td>
          <vs-td style="width: 12%; justify-content: center;">
            {{ tr.branchName }}
          </vs-td>
          <vs-td style="width: 10%; justify-content: center;">
            {{ $toCurrency(getOrderGross(tr)) }}
          </vs-td>
          <vs-td style="width: 10%; justify-content: center;" class="text-danger">
            {{ $toCurrency(getOrderDiscount(tr)) }}
          </vs-td>
          <vs-td style="width: 10%; justify-content: center;" class="font-bold">
            {{ $toCurrency(getOrderNetPrice(tr)) }}
          </vs-td>
          <vs-td style="width: 16%; justify-content: center;">
            {{ tr.userName }}
          </vs-td>
          <template class="expand-user" slot="expand">
            <div class="con-expand-users w-full p-4 bg-white border-top receipt-bg">
              <vs-row vs-type="flex" vs-w="12" class="receipt-container">
                <!-- Sipariş Kalemleri (Sol Taraf) -->
                <vs-col vs-type="block" vs-w="12" vs-lg="7" class="pr-md-6 border-right">
                  <div class="receipt-left">
                    <h6 class="bold text-muted mb-2 uppercase tracking-widest text-center border-bottom pb-2">SİPARİŞ DETAYI</h6>

                    <!-- Ürün Listesi Başlıkları -->
                    <div class="flex items-center text-xsmall weight-700 text-muted border-bottom pb-1 mb-2">
                      <div class="flex-grow pr-2">ÜRÜN ADI</div>
                      <div class="w-16 text-center">ADET</div>
                      <div class="w-24 text-right">TUTAR</div>
                    </div>

                    <!-- Ürün Listesi -->
                    <div v-for="entry in tr.cartEntries" :key="entry.id" class="item-row mb-2">
                      <div class="flex items-start text-small">
                        <div class="flex-grow text-dark font-medium leading-tight pr-2">
                          {{ entry.productName }}
                          <div v-if="entry.extras && entry.extras.length > 0" class="mt-1 pl-2">
                            <div v-for="extra in entry.extras" :key="extra.id" class="text-xsmall text-secondary italic">
                              + {{ extra.name }} <span v-if="extra.quantity > 1" class="ml-1">(x{{ extra.quantity }})</span>
                            </div>
                          </div>
                        </div>
                        <div class="w-16 text-center text-primary font-bold">
                          <span v-if="((entry.lastStartTime || entry.LastStartTime || entry.startTime || entry.StartTime) && (entry.lastStopTime || entry.LastStopTime || entry.endTime || entry.EndTime)) || (entry.totalHour && entry.totalHour > 0)" class="italic">
                            {{ getDurationMinutes(entry) }} dk
                          </span>
                          <span v-else>x{{ entry.quantity }}</span>
                        </div>
                        <div class="w-24 text-right font-semibold">{{ $toCurrency(entry.price) }}</div>
                      </div>
                    </div>

                    <!-- Hesap Özeti (Adisyon Altı) -->
                    <div class="mt-4 pt-3 border-top-thick receipt-summary">
                      <!-- Ara Toplam: Ürünlerin Toplamı -->
                      <div class="flex justify-between items-center mb-1 text-small font-bold">
                        <span class="text-muted">Ara Toplam:</span>
                        <span>{{ $toCurrency(calculateItemsTotal(tr.cartEntries)) }}</span>
                      </div>
                      
                      <!-- İndirimler (Ödeme olarak gelen indirimler) -->
                      <div v-for="disc in getDiscounts(tr.paymentInformations)" :key="disc.id" class="flex justify-between items-center mb-1 text-small text-danger italic">
                        <span>{{ disc.paymentMethod.name }}<span v-if="disc.unit == '%'"> (%{{ disc.value }})</span>:</span>
                        <span>-{{ $toCurrency(disc.price) }}</span>
                      </div>

                      <!-- Genel Toplam: Ara Toplam - İndirimler -->
                      <div class="flex justify-between items-center mt-2 pt-2 border-top-dashed">
                        <span class="text-small bold uppercase text-dark">GENEL TOPLAM:</span>
                        <span class="text-medium bold text-primary">{{ $toCurrency(calculateItemsTotal(tr.cartEntries) - calculateDiscountTotal(tr.paymentInformations)) }}</span>
                      </div>
                    </div>
                  </div>
                </vs-col>

                <!-- Ödeme Bilgileri (Sağ Taraf) -->
                <vs-col vs-type="block" vs-w="12" vs-lg="5" class="pl-md-6 mt-sm-6">
                  <div class="receipt-right">
                    <h6 class="bold text-success mb-3 uppercase tracking-widest text-center border-bottom pb-2">TAHSİLATLAR</h6>

                    <div v-if="getActualPayments(tr.paymentInformations).length === 0" class="text-center py-4 text-muted italic">
                      Henüz tahsilat kaydı yok.
                    </div>

                    <div 
                      v-for="payment in getActualPayments(tr.paymentInformations)" 
                      :key="payment.id" 
                      class="payment-card mb-3 p-3 rounded bg-light bg-opacity-30 border"
                    >
                      <div class="flex justify-between items-center">
                        <div class="flex flex-col">
                          <span class="text-small font-bold text-dark">{{ payment.paymentMethod.name }}</span>
                          <span v-if="payment.description" class="text-xsmall text-muted">{{ payment.description }}</span>
                        </div>
                        <div class="flex items-center">
                          <span class="text-medium font-bold text-success mr-3">
                            {{ $toCurrency(payment.price) }}
                          </span>
                        </div>
                      </div>
                      
                      <!-- Pavo/E-Arşiv Detayları -->
                      <div v-if="payment.financialDocument" class="mt-2 pt-2 border-top-dashed flex justify-between items-center text-xsmall">
                        <span class="text-primary font-medium">Sipariş No: {{ payment.financialDocument.orderNo || payment.financialDocument.invoiceNo || payment.financialDocument.documentNo }}</span>
                        <a v-if="$isAdmin() && payment.financialDocument.saleUid" class="text-underline text-info" target="_blank" 
                           :href="'https://pavopay.pavo.com.tr/InquiryOperations/SaleInquiryView/Index?q=' + payment.financialDocument.saleUid.replace(/-/g, '')">
                           E-Arşiv Linki
                        </a>
                      </div>
                    </div>
                    
                    <!-- Alt Bilgi / Personel -->
                    <div class="mt-6 text-center text-xsmall text-muted border-top pt-4">
                      <div>İŞLEMİ YAPAN: {{ tr.userName }}</div>
                      <div>TARİH: {{ tr.date }} - {{ tr.time }}</div>
                    </div>
                     <div class="text-center mb-4" v-if="tr.tableName">
                        <span class="px-3 py-1 text-primary font-bold text-xsmall">
                           {{ tr.tableName }}
                        </span>
                    </div>
                  </div>
                </vs-col>
              </vs-row>
            </div>
          </template>
        </vs-tr>
      </template>
    </vs-table>
    <vs-row vs-type="flex" vs-w="12" vs-justify="flex-end" vs-align="center">
      <span class="text-dark text-smaller weight-500"> Toplam Net Tutar : </span>
      <span class="text-primary text-small bold mr-1 ml-3">
        {{ $toCurrency(getTotalNetAmount) }} / {{ $toCurrency(totalPriceWithoutPaging) }}
      </span>
    </vs-row>
    <vs-row vs-type="flex" vs-w="12">
      <pagination-default
        :setCurrentPage="tableOptions.pageIndex"
        :totalLenght="calculatePageLength"
        @currentPage="getCurrentPage"
      ></pagination-default>
    </vs-row>

    <!-- v136: Yazdırma Bileşeni -->
    <div style="position: absolute; left: -9999px; top: -9999px; width: 80mm; opacity: 0; pointer-events: none;">
       <printer ref="printer" :printerId="'manualPrinterDiv'" />
    </div>
  </div>
</template>

<script>
import PaginationDefault from "../../PaginationDefault";
import { getOrderLogs, getOrderLogsForDealer, getOrderLogsExcel, getOrderLogsExcelForDealer, changePaymentMethod } from "@/api/Cart";
import { getPaymentMethodList } from "@/api/PaymentMethod";
import { getBranchOpenClose } from "@/api/DayOpen";
import GlobalFilter from "../../GlobalFilter";
import Printer from "../../SelfService/Printer.vue";
import _ from 'lodash';

export default {
  data() {
    return {
      tableOptions: {},
      sortingHeadIcon: "",
      sortingHeadIconBool: 1,
      currentPage: 0,
      itemsPerPage: 10,
      totalDataRow: 0,
      orderLogs: [],
      isFilterActive: false,
      filterOptions: [
        "dateRange",
        "timeRange",
        "branch",
        "product",
        "extra",
        "personal",
        "paymentMethod",
        "table",
        "price",
        "order",
        "orderSourceType",
        "isDiscountedOnly",
        "isNavigatedByQuestion",
        "isPrivateCampaignGiftOnly",
      ],
      filterOptionNames: [
        "Tarih",
        "Saat",
        "Şube",
        "Ürün",
        "Ekstra",
        "Personel",
        "Ödeme",
        "Masa",
        "Tutar",
        "Sipariş No",
        "Sipariş Türü",
        "İndirim Filtresi",
        "Pasta Sorusu",
        "8 Mood Kampanyası",
      ],
      isFiltererOpen: false,
      filterChips: [],
      totalPriceWithoutPaging: 0,
      
      // Ödeme Yöntemi Değiştirme
      isChangePaymentPopupActive: false,
      selectedPaymentToChange: null,
      selectedOrderToChange: null,
      newPaymentMethod: null,
      paymentChangeDescription: "",
      paymentMethods: [],
      openCloseData: null
    };
  },
  components: {
    PaginationDefault,
    GlobalFilter,
    Printer
  },
  computed: {
    calculatePageLength() {
      let mod = this.totalDataRow % this.itemsPerPage;
      return mod > 0
        ? (this.totalDataRow - mod) / this.itemsPerPage + 1
        : this.totalDataRow / this.itemsPerPage;
    },
    getTotalGrossAmount() {
      return this.orderLogs.reduce((total, num) => {
        return total + num.totalPrice;
      }, 0);
    },
    getTotalDiscountAmount() {
      return this.orderLogs.reduce((total, num) => {
        return total + this.getOrderDiscount(num);
      }, 0);
    },
    getTotalNetAmount() {
      return this.orderLogs.reduce((total, num) => {
        return total + this.getOrderNetPrice(num);
      }, 0);
    },
  },
  methods: {
    getOrderSourceBadge(tr) {
      if (!tr) return { text: 'Şube', color: 'primary', icon: 'icon-monitor' };
      if (tr.isMobile || tr.IsMobile) {
        return { text: 'Mobil', color: 'success', icon: 'icon-smartphone' };
      }
      const source = tr.orderSource !== undefined ? tr.orderSource : tr.OrderSource;
      if (source === 2 || source === 'Getir') {
        return { text: 'Getir', color: 'warning', icon: 'icon-shopping-bag' };
      } else if (source === 3 || source === 'YemekSepeti') {
        return { text: 'Yemeksepeti', color: 'danger', icon: 'icon-shopping-bag' };
      } else if (source === 4 || source === 'TrendyolYemek') {
        return { text: 'Trendyol', color: 'dark', icon: 'icon-shopping-bag' };
      } else if (source === 1 || source === 'SelfService') {
        return { text: 'Şube', color: 'primary', icon: 'icon-monitor' };
      }
      return { text: 'Şube', color: 'primary', icon: 'icon-monitor' };
    },
    getExcel() {
      if (this.$isRegionalCenterBranch()) {
        getOrderLogsExcelForDealer(this.tableOptions).then(res => {
        if (res && res.status == 200) {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement('a');
          link.href = url;
          let now = this.$now.date();
          link.setAttribute('download', 'Sıcak Satış' + now.getDate() + " " + this.$months()[now.getMonth()]
            .name + " " + now.getFullYear() + '.xlsx');
          document.body.appendChild(link);
          link.click();

          this.$vs.notify({
            color: "success",
            title: "Başarılı",
            text: "Excel Export Başarılı !"
          });
        } else {
          this.$vs.notify({
            color: "danger",
            title: "Hata : " + res.status,
            text: "Excel Export İşlemi Başarısız !"
          });
        }
      }).catch(() => {
        this.$vs.notify({
          color: "danger",
          title: "Hata !",
          text: "Sunucu Bağlantı Hatası !"
        });
      })
      }else{
        getOrderLogsExcel(this.tableOptions).then(res => {
        if (res && res.status == 200) {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement('a');
          link.href = url;
          let now = this.$now.date();
          link.setAttribute('download', 'Sıcak Satış Raporu' + now.getDate() + " " + this.$months()[now.getMonth()]
            .name + " " + now.getFullYear() + '.xlsx');
          document.body.appendChild(link);
          link.click();

          this.$vs.notify({
            color: "success",
            title: "Başarılı",
            text: "Excel Export Başarılı !"
          });
        } else {
          this.$vs.notify({
            color: "danger",
            title: "Hata : " + res.status,
            text: "Excel Export İşlemi Başarısız !"
          });
        }
      }).catch(() => {
        this.$vs.notify({
          color: "danger",
          title: "Hata !",
          text: "Sunucu Bağlantı Hatası !"
        });
      })}
    },
    saveOptions(filterOptions, filterChips) {
      this.isFilterActive = false;
      if (_.isEqual(this.tableOptions, filterOptions)) return;
      this.tableOptions = _.cloneDeep(filterOptions);
      this.filterChips = _.cloneDeep(filterChips);
    },
    clearFilter() {
      this.tableOptions = {
        sortBy: "Created",
        sortDirection: "desc",
        pageIndex: 0,
        pageSize: this.itemsPerPage,
        dateRange: {
          startDate:
            this.$now().getHours() >= 0 && this.$now().getHours() <= 2
              ? this.$preDate()
              : this.$now.date(),
          endDate:
            this.$now().getHours() >= 0 && this.$now().getHours() <= 2
              ? this.$preDate()
              : this.$now.date(),
        },
        timeRange: {
          startTime: null,
          endTime: null,
        },
        paymentMethod: null,
        extra: null,
        product: null,
        personal: null,
        order: null,
        table: null,
        price: {
          min: null,
          max: null,
        },
        branch: (this.$isCenterBranch() || this.$isRegionalCenterBranch()) ? null : this.$currentUser.branch,
        orderSourceType: null,
        isDiscountedOnly: null,
        isNavigatedByQuestion: false,
        isPrivateCampaignGiftOnly: false,
      };
      this.filterChips.length = 0;
    },
    removeFilter(col, index) {
      if (col === "branch") this.tableOptions[col] = (this.$isCenterBranch() || this.$isRegionalCenterBranch()) ? null : this.$currentUser.branch;
      else this.tableOptions[col] = null;
      this.filterChips.splice(index, 1);
    },
    setSortingOptions(val) {
      if (this.tableOptions.sortBy != val) this.sortingHeadIconBool = 1;
      this.tableOptions.sortBy = val;
      switch (this.sortingHeadIconBool) {
        case 1:
          this.sortingHeadIconBool++;
          this.sortingHeadIcon = "icon-arrow-up";
          break;
        case 2:
          this.sortingHeadIconBool++;
          this.sortingHeadIcon = "icon-arrow-down";
          break;
        case 3:
          this.sortingHeadIconBool = 1;
          this.sortingHeadIcon = "";
          this.tableOptions.sortBy = "";
      }
    },
    getCurrentPage(currentx) {
      this.currentPage = currentx - 1;
    },
    getOrderLogs() {
      this.$vs.loading();
      if (this.$isRegionalCenterBranch()) {
        getOrderLogsForDealer(this.tableOptions)
        .then((res) => {
          if (res && res.status == 200) {
            this.orderLogs = res.data.items;
            this.totalDataRow = res.data.totalCount;
            this.totalPriceWithoutPaging = res.data.totalPrice
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Hata : " + res.status,
            });
          }
        })
        .catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Satış Kayıtları Yüklenemedi ! ",
          });
        })
        .finally(() => {
          this.$vs.loading.close();
        });
      } else {
        getOrderLogs(this.tableOptions)
        .then((res) => {
          if (res && res.status == 200) {
            this.orderLogs = res.data.items;
            this.totalDataRow = res.data.totalCount;
            this.totalPriceWithoutPaging = res.data.totalPrice
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Hata : " + res.status,
            });
          }
        })
        .catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Satış Kayıtları Yüklenemedi ! ",
          });
        })
        .finally(() => {
          this.$vs.loading.close();
        });
      }
    },
    getOrderGross(tr) {
      if (!tr) return 0;
      const gross = this.calculateItemsTotal(tr.cartEntries);
      return gross > 0 ? gross : (tr.totalPrice || 0);
    },
    getOrderDiscount(tr) {
      if (!tr) return 0;
      const discount = this.calculateDiscountTotal(tr.paymentInformations);
      if (discount > 0) return discount;
      
      if (tr.promotionPrice !== undefined && tr.promotionPrice !== null) return tr.promotionPrice;
      if (tr.PromotionPrice !== undefined && tr.PromotionPrice !== null) return tr.PromotionPrice;
      return 0;
    },
    getOrderNetPrice(tr) {
      if (!tr) return 0;
      if (tr.netPrice !== undefined && tr.netPrice !== null) return tr.netPrice;
      if (tr.NetPrice !== undefined && tr.NetPrice !== null) return tr.NetPrice;
      
      const gross = this.getOrderGross(tr);
      const discount = this.getOrderDiscount(tr);
      const calculatedNet = gross - discount;
      return calculatedNet >= 0 ? calculatedNet : 0;
    },
    isDiscountPayment(payment) {
      if (!payment || !payment.paymentMethod || !payment.paymentMethod.name) return false;
      const name = payment.paymentMethod.name.toLowerCase();
      const keywords = ["indirim", "i̇ndirim", "discount", "ındırım", "ikram", "i̇kram", "treat", "iskonto", "kampanya", "düşüm", "dusum"];
      return keywords.some(kw => name.includes(kw));
    },
    getActualPayments(payments) {
      if (!payments) return [];
      return payments.filter(p => !this.isDiscountPayment(p));
    },
    getDiscounts(payments) {
      if (!payments) return [];
      return payments.filter(p => this.isDiscountPayment(p));
    },
    calculateItemsTotal(entries) {
      if (!entries) return 0;
      return entries.reduce((acc, curr) => acc + curr.price, 0);
    },
    calculateDiscountTotal(payments) {
      if (!payments) return 0;
      return this.getDiscounts(payments).reduce((acc, curr) => acc + curr.price, 0);
    },
    printOrderManual(tr) {
      if (!tr || !tr.id) return;
      
      const orderForPrint = JSON.parse(JSON.stringify(tr));
      const gross = this.calculateItemsTotal(tr.cartEntries);
      const discount = this.calculateDiscountTotal(tr.paymentInformations);
      
      orderForPrint.totalPrice = gross;      // Brüt (Ara Toplam)
      orderForPrint.promotionPrice = discount; // İndirim
      orderForPrint.netPrice = gross - discount; // Net (Ödenen)
      orderForPrint.isAdisyon = false; // "Ödenen Toplam" yazması için
      
      if (this.$refs.printer && typeof this.$refs.printer.fetchAndPrint === 'function') {
        this.$vs.loading();
        this.$refs.printer.fetchAndPrint(
          tr.id, 
          1,       // Copy count
          true,    // isFinal
          null,    // expectedNo
          orderForPrint,
          false,   // forceSignalR
          true     // forceBrowser
        ).finally(() => {
          this.$vs.loading.close();
        });
      }
    },
    parseSafeDate(val) {
      if (!val) return new Date(0);
      if (val instanceof Date) return val;
      
      let d = new Date(val);
      if (!isNaN(d.getTime())) {
          const now = new Date();
          if (d.getTime() > now.getTime() + 3600000) {
              d = new Date(d.getTime() - 3 * 3600000);
          }
          return d;
      }
      
      if (typeof val === "string" && val.includes(".")) {
          try {
              const parts = val.split(/[. :]/);
              if (parts.length >= 3) {
                  const day = parseInt(parts[0]);
                  const month = parseInt(parts[1]) - 1;
                  const year = parseInt(parts[2]);
                  const hour = parts[3] ? parseInt(parts[3]) : 0;
                  const min = parts[4] ? parseInt(parts[4]) : 0;
                  const sec = parts[5] ? parseInt(parts[5]) : 0;
                  return new Date(year, month, day, hour, min, sec);
              }
          } catch(e) { console.error("parseSafeDate fallback error", e); }
      }
      return new Date(0);
    },
    getDurationMinutes(entry) {
      const totalHour = entry.totalHour || entry.TotalHour;
      if (totalHour && totalHour > 0) {
          return Math.ceil(totalHour * 60);
      }

      const startStr = entry.lastStartTime || entry.LastStartTime || entry.startTime || entry.StartTime || entry.createdDate || entry.CreatedDate;
      const stopStr = entry.lastStopTime || entry.LastStopTime || entry.endTime || entry.EndTime;
      
      if (startStr && stopStr) {
          const start = this.parseSafeDate(startStr);
          const stop = this.parseSafeDate(stopStr);
          
          if (start.getTime() > 0 && stop.getTime() >= start.getTime()) {
              const diffMs = stop.getTime() - start.getTime();
              const diffMins = Math.ceil(diffMs / (1000 * 60));
              return diffMins > 0 ? diffMins : 1;
          }
      }
      return 0;
    },
    fetchOpenCloseData() {
      getBranchOpenClose().then(res => {
        if (res && res.data) {
          this.openCloseData = res.data;
        }
      }).catch(err => {
        console.error("Failed to fetch branch open close data", err);
      });
    },
    isPaymentChangeAllowed(tr) {
      if (!this.openCloseData || !this.openCloseData.lastOpenDate) return false;
      return tr.date === this.openCloseData.lastOpenDate;
    },
    isDiscountMethod(method) {
      if (!method || !method.name) return false;
      const name = method.name.toLowerCase();
      const keywords = ["indirim", "i̇ndirim", "discount", "ındırım", "ikram", "i̇kram", "treat", "iskonto", "kampanya", "düşüm", "dusum"];
      return keywords.some(kw => name.includes(kw));
    },
    fetchPaymentMethods() {
      getPaymentMethodList().then(res => {
        if (res && Array.isArray(res)) {
          this.paymentMethods = res;
        } else if (res && res.data && Array.isArray(res.data)) {
          this.paymentMethods = res.data;
        }
      }).catch(err => {
        console.error("Payment method list error, trying fallback:", err);
        import("@/api/Filter").then(filterApi => {
          filterApi.filterPaymentMethodNameList().then(res => {
            this.paymentMethods = res;
          });
        });
      });
    },
    openChangePaymentModal(payment, order) {
      this.selectedPaymentToChange = payment;
      this.selectedOrderToChange = order;
      this.newPaymentMethod = null;
      this.paymentChangeDescription = "";
      this.isChangePaymentPopupActive = true;
    },
    getFilteredPaymentMethods() {
      if (!this.paymentMethods || !this.selectedPaymentToChange || !this.selectedPaymentToChange.paymentMethod) return this.paymentMethods || [];
      const currentName = this.selectedPaymentToChange.paymentMethod.name;
      return this.paymentMethods.filter(x => {
        const isOther = x.name && (x.name.toUpperCase() === 'DİĞER' || x.name.toUpperCase() === 'DIĞER' || x.name.toUpperCase() === 'OTHER');
        return !this.isDiscountMethod(x) && !isOther && x.name !== currentName;
      });
    },
    submitPaymentChange() {
      if (!this.newPaymentMethod || !this.paymentChangeDescription || this.paymentChangeDescription.trim().length < 3) {
        this.$vs.notify({
          color: "warning",
          title: "Eksik Bilgi",
          text: "Lütfen yeni ödeme yöntemini seçin ve geçerli bir açıklama girin."
        });
        return;
      }

      this.$vs.loading();
      const payload = {
        orderId: this.selectedOrderToChange.id,
        paymentInformationId: this.selectedPaymentToChange.id,
        newPaymentMethodId: this.newPaymentMethod.id,
        description: this.paymentChangeDescription
      };

      changePaymentMethod(payload)
        .then(res => {
          if (res && (res.status === 200 || res.success)) {
            this.$vs.notify({
              color: "success",
              title: "Başarılı",
              text: "Ödeme yöntemi başarıyla güncellendi ve raporlara kaydedildi."
            });
            this.isChangePaymentPopupActive = false;
            this.getOrderLogs();
          } else {
            throw new Error("API hatası");
          }
        })
        .catch(error => {
          console.error("Payment change error:", error);
          this.$vs.notify({
            color: "danger",
            title: "Hata",
            text: (error.response && error.response.data) ? error.response.data : "İşlem sırasında bir hata oluştu. Lütfen tekrar deneyiniz."
          });
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    }
  },
  watch: {
    tableOptions: {
      deep: true,
      handler() {
        this.$nextTick(() => {
          this.getOrderLogs();
        });
      },
    },
    currentPage: function (val) {
      this.tableOptions.pageIndex = val;
    },
    sortingHeadIconBool: function () {
      switch (this.sortingHeadIconBool) {
        case 1:
          this.tableOptions.sortDirection = "";
          break;
        case 2:
          this.tableOptions.sortDirection = "asc";
          break;
        case 3:
          this.tableOptions.sortDirection = "desc";
          break;
      }
      this.currentPage = 0;
      this.tableOptions.pageIndex = this.currentPage;
    },
    itemsPerPage: function (val) {
      this.currentPage = 0;
      this.tableOptions.pageSize = val;
      this.tableOptions.pageIndex = this.currentPage;
    }
  },
  created: function () {
    this.clearFilter();
    this.fetchPaymentMethods();
    this.fetchOpenCloseData();
    if (!this.$isCenterBranch()) {
      if (!this.$isRegionalCenterBranch()) {
        let branchPropIndex = this.filterOptions.indexOf("branch");
      this.filterOptions.splice(branchPropIndex, 1);
      this.filterOptionNames.splice(branchPropIndex, 1);

      delete this.tableOptions["branch"];
      }
    }
  },
};
</script>

<style>
.receipt-bg {
  background: white url('https://www.transparenttextures.com/patterns/white-paper.png');
}

.receipt-container {
  max-width: 1000px;
  margin: 0 auto;
}

.border-top-thick {
  border-top: 2px solid #333;
}

.receipt-summary {
  background: #fdfdfd;
  padding: 10px;
  border: 1px dashed #ccc;
}

.text-large {
  font-size: 1.4rem;
}

.text-medium {
  font-size: 1.15rem;
}

.tracking-widest {
  letter-spacing: 0.1em;
}

.payment-card {
  box-shadow: 0 2px 4px rgba(0,0,0,0.02);
  transition: all 0.2s;
}

.payment-card:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 6px rgba(0,0,0,0.05);
}

.text-underline {
  text-decoration: underline;
}

@media (min-width: 992px) {
  .pr-md-6 { padding-right: 1.5rem !important; }
  .pl-md-6 { padding-left: 1.5rem !important; }
}

@media (max-width: 991px) {
  .receipt-left, .receipt-right {
    padding: 0 !important;
  }
  .border-right {
    border-right: none !important;
    border-bottom: 2px dashed #eee;
    margin-bottom: 2rem;
    padding-bottom: 2rem;
  }
  .mt-sm-6 { margin-top: 1.5rem !important; }
  .pr-md-6, .pl-md-6 { padding: 0 !important; }
}

#orderLogsTable .con-tablex {
  max-height: calc(100vh - 230px);
  overflow-y: auto;
}

#orderLogsTable tr:not(.vs-table--expand-row) td,
#orderLogsTable tr:not(.vs-table--expand-row) td .con-vs-char,
#orderLogsTable tr:not(.vs-table--expand-row) td .vs-chip,
#orderLogsTable tr:not(.vs-table--expand-row) td .vs-button {
  justify-content: center !important;
  align-items: center !important;
  text-align: center !important;
  margin: 0 auto !important;
}
</style>
